var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlerts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 14C6.9122 14 5.84883 13.6774 4.94436 13.0731C4.03989 12.4687 3.33494 11.6097 2.91866 10.6048C2.50238 9.59976 2.39346 8.4939 2.60568 7.427C2.8179 6.3601 3.34172 5.3801 4.11091 4.61091C4.8801 3.84172 5.86011 3.3179 6.927 3.10568C7.9939 2.89346 9.09977 3.00238 10.1048 3.41866C11.1098 3.83494 11.9687 4.53989 12.5731 5.44436C13.1774 6.34883 13.5 7.4122 13.5 8.5C13.5 9.95869 12.9205 11.3576 11.8891 12.3891C10.8576 13.4205 9.45869 14 8 14ZM8 4C7.10998 4 6.23995 4.26392 5.49993 4.75838C4.75991 5.25285 4.18314 5.95565 3.84254 6.77792C3.50195 7.60019 3.41283 8.50499 3.58647 9.3779C3.7601 10.2508 4.18868 11.0526 4.81802 11.682C5.44736 12.3113 6.24918 12.7399 7.12209 12.9135C7.99501 13.0872 8.89981 12.998 9.72208 12.6575C10.5443 12.3169 11.2471 11.7401 11.7416 11.0001C12.2361 10.26 12.5 9.39001 12.5 8.5C12.5 7.30652 12.0259 6.16193 11.182 5.31802C10.3381 4.4741 9.19347 4 8 4Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.295 10.5L7.5 8.705V5.5H8.5V8.29L10 9.795L9.295 10.5Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79082 2.00157L2.00018 3.79597L2.70803 4.50233L4.49867 2.70794L3.79082 2.00157Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2076 1.99718L11.4997 2.70355L13.2904 4.49794L13.9982 3.79158L12.2076 1.99718Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerts);
export default __webpack_public_path__ + "static/media/alerts.20878a699d933f07548d11387b04f413.svg";
export { ForwardRef as ReactComponent };